import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _RequestMaintenance, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ListRequestItemsMantenance } from "./Components/ListRequestItemsMantenance";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}


interface Props {
    configProcedure: ProcedureFunctions;
}

export const MD005 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_RequestMaintenance);
    const [props, setProps] = useState<any>({});
    const [request, setRequest] = useState<any>({});


    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        instance.getRequestMaintenanceCatalogPorPropiedades({ IDProceudreIMP: props.IDProceudreIMP }, null).then(
            (resp) => {
                if (resp?.length > 0 && resp[0].DataBeanProperties) {
                    setRequest(resp[0].DataBeanProperties);
                }
            }
        ).catch(
            err => { console.log("No se pudo cargar la informacion") }
        )
    }, [props])

    const onExportMap = (obj?: any) => {
        instance.updateRequestMaintenance({
            ...request,
            ReferenceSpareJSON: bean.ReferenceSpareJSON
        });

        const transformArrayForTable = (array) => {
            const result = {};
            array.forEach((item, index) => {
                result[`Item ${index + 1}`] = `Nombre: ${item.Name} - Cantidad: ${item.Quantity}`
            });
            return result;
        };

        const ref = transformArrayForTable(JSON.parse(bean.ReferenceSpareJSON));

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(_single.jsonToBootstrapTable(ref));
        }
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean);
        }
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <fieldset className="p-2">
                    <ListRequestItemsMantenance jsonProps={bean.ReferenceSpareJSON} onChange={(e) => { setBean({ ...bean, ReferenceSpareJSON: e }) }} />
                </fieldset>
            </div>
            <div className="col-md-12 mt-4">
                <BasicButton eventClick={onExportMap} icon="ri-send-plane-line" children={`Solicitar Repuestos`} />
            </div>
        </div>
    )
}